module.exports = __webpack_public_path__ + "img/Gallery_2_26.44e41b30.jpeg";